var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"easyscreen-fullscreen-button",on:{"click":_vm.toggleFullscreen}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }